import React from 'react'
// import Footer from './Footer';
import './Balaji.css';
import { Link } from 'react-router-dom';
const Home = () => {
  return (

    <div className='newclass' style={{ backgroundColor: "#000435" }}>

      <div className="video-container">
        <video autoPlay loop muted playsInline className="background-video">
          <source src="/Bgvideo/web video3.mp4" type="video/mp4" />

        </video>
        <div className="text-overlay">
          <h4 className='premium'> Premium Web Development Agency</h4>
          <h1 className='grow'>We Grow Business Online</h1>
          <h4 className='custome'>Custom Websites, Branding & Digital Marketing</h4>
        </div>
      </div>
      <div className='hori'>
        <hr className="horizontal-line" />
      </div>

      <div className='main-container'>
        <div className='leftone'>
          <h1 className='creative-web' style={{ fontFamily: "fantasy" }}> Creative Web Agency Delivering Custom Solutions</h1>
          <br>
          </br><br></br>
          <h4 className='conversion'> Custom Web Design Solutions To Drive Conversions</h4><br>
          </br><br></br>
          <h4 className='conversion'> Effective Marketing Campaigns To Generate Growth</h4><br>
          </br><br></br>
          <h4 className='conversion'> Tailored Branding Strategies To Drive Engagement</h4><br>
          </br>
          <div>
            <h7 className="growing">  Balaji IT Services is a web design company & digital marketing
              agency focused
              on growing brands online. We create effective brand strategies, custom web design,
              development, and digital marketing solutions to generate greater brand engagement
              and conversions. We work closely with our clients to ensure each project meets their
              brand guidelines and business goals and provide technical and marketing expertise to ensure optimal results.</h7>
          </div>
        </div>
        <div className='rightone'>
          <img src="/images/Creative-web.png" alt="..." ></img>

        </div>

      </div>
      <div className='hori'>
        <hr className="horizontal-line" />
      </div>

      <div className='maincontainer-second'>

        <div className='curve'>
          <h1 className='our ' > OUR SOLUTIONS</h1>

          <h1 className='ahead' > We help people's stay ahead of the curve</h1>

          <h4 className='talent' > Specializing in IT Consulting and Talent Solutions, we connect business strategy and technology to drive measurable results</h4>
        </div>

        <div className='image-side'>
          <img src="/images/Our-solutions.jpg"  alt="..." />
        </div>



      </div>
    
      <div className='ours' >
        <h1 style={{ marginTop: "5%" }}> Our Services</h1>

        <div style={{ display: "flex", flexWrap: "wrap",marginTop:"2%" }}>
          <div className="card">
            <img src="/images/Website-development.jpg" className="card-img-top" alt=" " />
            <div className="card-body">
              <Link to="/WebsiteDevelopment">
                <h5 className="card-title"> Website Development</h5>
              </Link>

            </div>
          </div>


          <div className="card">
            <img src="/images/Graphic-home.jpg" className="card-img-top" alt=" " />
            <div className="card-body">
              <Link to="/GraphicDesign">
                <h5 className="card-title"> Graphic Design</h5>
              </Link>

            </div>
          </div>

          <div className="card" >
            <img src="/images/Androiddeve-home.jpg" className="card-img-top" alt=" " />
            <div className="card-body">
              <Link to="/AppD">
                <h5 className="card-title"> Android Development </h5>
              </Link>

            </div>
          </div>

          <div className="card">
            <img src="/images/Digital-marketing.png" className="card-img-top" alt=" " />
            <div className="card-body">
              <Link to="/Dm">
                <h5 className="card-title">Digital Marketing</h5>
              </Link>

            </div>
          </div>
        </div>

      </div>




      {/* <Footer/> */}
    </div>
  )
}

export default Home;

